<template>
    <main class='main-content'>
        <div v-if="pageTopReady" class="subscribe-sim-page-title-wrap">
            <reo-page-title
                :title="pageTopTitle"
                :subtitle="pageTopSubtitle"
            />
        </div>
        <div
            v-else-if="isDeferredPlanSelectRoute"
            class="subscribe-sim-page-title-placeholder"
            aria-hidden="true"
        />
        <router-view :key="$route.fullPath"/>
    </main>
</template>

<script lang="ts">
import Vue from 'vue';

export interface ISubscribeSimPageTopPayload { title: string; subtitle: string;  }

/** 套餐列表/选购依赖子组件异步 init 才能确定页头，避免先用默认文案再闪成切换文案 */
const DEFERRED_PAGE_TOP_ROUTE_NAMES = new Set( ['sim-plan-list', 'sim-plan-choose'] );

export default Vue.extend({
    components: {
    },
    data() {

        return {
            pageTopOverride: null as ISubscribeSimPageTopPayload | null,
            pageTopReady: false
        };

    },
    provide() {

        return {
            setSubscribeSimPageTop: ( payload: ISubscribeSimPageTopPayload | null ) => {

                this.pageTopOverride = payload;
                this.pageTopReady = true;

            }
        };

    },
    computed: {
        isDeferredPlanSelectRoute(): boolean {

            return DEFERRED_PAGE_TOP_ROUTE_NAMES.has( String( this.$route.name ));

        },
        pageTopTitle(): string {

            if ( this.pageTopOverride ) return this.pageTopOverride.title;
            return this.$t( 'subscribe_plan.top_info.title' ) as string;

        },
        pageTopSubtitle(): string {

            if ( this.pageTopOverride ) return this.pageTopOverride.subtitle;
            return this.$t( 'subscribe_plan.top_info.content' ) as string;

        }
    },
    watch: {
        /** 同 name 下仅 query 变化（如换卡）也要重算页头，故用 fullPath */
        '$route.fullPath': {

            handler() {

                if ( this.isDeferredPlanSelectRoute ) {

                    this.pageTopOverride = null;
                    this.pageTopReady = false;
                    return;

                }
                this.pageTopOverride = null;
                this.pageTopReady = true;

            },
            immediate: true

        }
    }
});
</script>

<style lang="less" scoped>
    .main-content{
        .main-content();
        padding-top: 0;
        .mobile({
            padding-bottom: 50px;
        });
    }
    .subscribe-sim-page-title-placeholder {
        /* 与 ReoPageTitle 区块高度大致对齐，减轻首次出现的布局跳动 */
        min-height: 200px;
        box-sizing: border-box;
        .mobile({
            min-height: 140px;
        });
    }
</style>
